(() => {
  const DESKTOP_QUERY = '(min-width: 750px) and (pointer: fine)';
  const media = window.matchMedia(DESKTOP_QUERY);
  let frame = 0;
  let resizeObserver;
  let mutationObserver;
  let dragging = false;
  let dragStartY = 0;
  let dragStartTop = 0;

  const root = document.documentElement;
  const rail = document.querySelector('[data-nx-scrollbar]');
  const track = rail?.querySelector('[data-nx-scrollbar-track]');
  const thumb = rail?.querySelector('[data-nx-scrollbar-thumb]');

  if (!rail || !track || !thumb) return;

  const documentHeight = () => Math.max(
    document.body?.scrollHeight || 0,
    document.body?.offsetHeight || 0,
    root.clientHeight,
    root.scrollHeight,
    root.offsetHeight
  );

  const metrics = () => {
    const viewport = window.innerHeight;
    const total = documentHeight();
    const maxScroll = Math.max(0, total - viewport);
    const trackHeight = Math.max(0, track.clientHeight - 4);
    const proportional = total > 0 ? trackHeight * (viewport / total) : trackHeight;
    const thumbHeight = Math.min(trackHeight, Math.max(58, proportional));
    const maxTop = Math.max(0, trackHeight - thumbHeight);
    return { maxScroll, thumbHeight, maxTop };
  };

  const paint = () => {
    frame = 0;
    if (!media.matches) {
      root.classList.remove('nx-custom-scrollbar');
      rail.classList.remove('is-visible');
      return;
    }

    root.classList.add('nx-custom-scrollbar');
    const { maxScroll, thumbHeight, maxTop } = metrics();
    const top = maxScroll > 0 ? Math.min(maxTop, (window.scrollY / maxScroll) * maxTop) : 0;

    thumb.style.height = `${thumbHeight}px`;
    thumb.style.transform = `translate3d(0, ${top + 2}px, 0)`;
    rail.classList.toggle('is-visible', maxScroll > 2);
  };

  const schedule = () => {
    if (!frame) frame = window.requestAnimationFrame(paint);
  };

  const scrollFromThumbTop = (top) => {
    const { maxScroll, maxTop } = metrics();
    if (maxTop <= 0 || maxScroll <= 0) return;
    const clamped = Math.max(0, Math.min(maxTop, top));
    window.scrollTo({ top: (clamped / maxTop) * maxScroll, behavior: 'auto' });
  };

  track.addEventListener('pointerdown', (event) => {
    if (event.target === thumb) return;
    const rect = track.getBoundingClientRect();
    const { thumbHeight } = metrics();
    scrollFromThumbTop(event.clientY - rect.top - (thumbHeight / 2) - 2);
  });

  thumb.addEventListener('pointerdown', (event) => {
    if (event.button !== 0) return;
    dragging = true;
    dragStartY = event.clientY;
    const transform = new DOMMatrixReadOnly(getComputedStyle(thumb).transform);
    dragStartTop = Math.max(0, transform.m42 - 2);
    thumb.classList.add('is-dragging');
    thumb.setPointerCapture(event.pointerId);
    event.preventDefault();
  });

  thumb.addEventListener('pointermove', (event) => {
    if (!dragging) return;
    scrollFromThumbTop(dragStartTop + event.clientY - dragStartY);
    event.preventDefault();
  });

  const endDrag = (event) => {
    if (!dragging) return;
    dragging = false;
    thumb.classList.remove('is-dragging');
    if (thumb.hasPointerCapture?.(event.pointerId)) thumb.releasePointerCapture(event.pointerId);
  };

  thumb.addEventListener('pointerup', endDrag);
  thumb.addEventListener('pointercancel', endDrag);

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule, { once: true });
  media.addEventListener?.('change', schedule);

  if ('ResizeObserver' in window) {
    resizeObserver = new ResizeObserver(schedule);
    resizeObserver.observe(root);
    if (document.body) resizeObserver.observe(document.body);
  }

  if ('MutationObserver' in window && document.body) {
    mutationObserver = new MutationObserver(schedule);
    mutationObserver.observe(document.body, { childList: true, subtree: true });
  }

  schedule();
})();
